import { isLoadingReducer, singleValueReducer } from 'store/reducerUtils';
import { getInvoiceRecipients } from 'modules/settings/submodules/clients/deals/components/DealForm/components/InvoiceRecipientSelect/store/actions';
import { IInvoiceRecipient } from 'shared/models/Deal';

export const invoiceRecipients = singleValueReducer(getInvoiceRecipients.successType, [] as IInvoiceRecipient[]);

export const invoiceRecipientsIsLoading = isLoadingReducer(getInvoiceRecipients);
